import * as z from "zod";

export const CookieConsentSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  necessary: z.boolean().default(true),
  analytics: z.boolean().default(false),
  marketing: z.boolean().default(false),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createCookieConsentSchema = CookieConsentSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateCookieConsentSchema = z.object({
  analytics: z.boolean().optional(),
  marketing: z.boolean().optional(),
});

export const cookiePreferencesSchema = z.object({
  accept_all: z.boolean().optional(),
  preferences: z.object({
    necessary: z.boolean().default(true),
    analytics: z.boolean().optional(),
    marketing: z.boolean().optional(),
  }),
});

// Schema for validating cookie settings in requests
export const cookieAccountSchema = z.object({
  name: z.string(),
  value: z.string(),
  maxAge: z.number().optional(),
  httpOnly: z.boolean().optional(),
  secure: z.boolean().optional(),
  sameSite: z.enum(["lax", "strict", "none"]).optional(),
  path: z.string().optional(),
});
